<template>
  <ValidationProvider ref="validate" :vid="vid" :name="label" :rules="rules" v-slot="{ errors }">
    <v-select
      class="text-field"
      v-model="model"
      :items="items"
      :label="label"
      :outlined="outlined"
      :filled="filled"
      :append-icon="icon"
      :disabled="disabled"
      :readonly="readonly"
      :error-messages="errors[0]"
      @input="$emit('update:model', model);"
    ></v-select>
  </ValidationProvider>
</template>
<script>
export default {
  name: 'Select',
  props: {
    vid: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: [
        {
          text: 'Sample',
          value: '1'
        }
      ]
    },
    label: {
      type: String,
      default: ''
    },
    outlined: {
      type: Boolean,
      default: false
    },
    filled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Object,
      default: null
    },
    value: {
      type: [String, Number],
      default: null
    }
  },
  watch: {
    value(value) {
      this.model = value;
    }
  },
  created() {
    this.model = this.value;

    if (this.rules) {
      this.validated = false;
    }
  },
  mounted() {
    //emit errors
    this.$refs.validate.$watch('errors', value => {
      this.$emit('onError', value[0]);
    });
  },
  methods: {
    validate() {
      if (0 >= this.$refs.validate.errors.length) {
        return true;
      } else {
        return false;
      }
    }
  },
  data() {
    return {
      model: '',
      validated: true
    };
  }
};
</script>

<style scoped>
.text-field >>> .v-select__selection--comma {
  font-size: 13px;
}

.text-field >>> .v-label {
  font-size: 13px;
}
</style>
